import { FaHamburger, FaHandSparkles, FaMoon, FaRegStar, FaStar, FaStarAndCrescent, FaStarOfDavid, FaStarOfLife, FaSun, FaTerminal } from "react-icons/fa";
import { ImCross } from "react-icons/im";
import { BrowserRouter as Router, Route } from 'react-router-dom';
import { Link as LinkScroll } from 'react-scroll'
import { Link as LinkRouter } from 'react-router-dom'
import { useMediaQuery } from '@material-ui/core';

import { React, useState, useEffect } from 'react';
import DarkModeSwitch from "./DarkModeSwitch";
import ScrollToTop, { smoothScrollToTop } from "./utils";
import { useLocation } from "react-router-dom";
import { handle } from "mdast-util-to-markdown/lib/handle";


const Navbar = ({ theme, setTheme }) => {
  const [isToggled, setIsToggled] = useState(false);
  const isMobile = useMediaQuery('(max-width: 768px)');
  const toggle = () => setIsToggled(!isToggled);
  const pwTermLink = "https://philippwulff.github.io/pw-term/";
  const [scrollPosition, setScrollPosition] = useState(0);
  const [navbarWidth, setNavbarWidth] = useState(Math.min(768, window.innerWidth));

  useEffect(() => {
      // Update the screen width.
      setNavbarWidth(Math.min(768, window.innerWidth));
      // Update the scroll position.
      const handleScroll = () => {setScrollPosition(window.pageYOffset)};
      window.addEventListener('scroll', handleScroll, { passive: true });
      return () => {
          window.removeEventListener('scroll', handleScroll);
      };
  }, []);

  const navButtons = ( sidebarMode = false ) => {
    function onclickFunc(){
      if (sidebarMode){
        toggle();
      }
      window.scrollTo(0, 0);
    }
    const linkClassName = 'p-5 md:p-1 hover:underline underline-offset-4';
    return <>
      <LinkRouter to="/" onClick={onclickFunc} className={linkClassName}>Home</LinkRouter>
      <LinkRouter to="/projects" onClick={onclickFunc} className={linkClassName}>Projects</LinkRouter>
      <LinkRouter to="/blog" onClick={onclickFunc} className={linkClassName}>Blog</LinkRouter>
      <FaTerminal 
        onClick={() => {window.open(pwTermLink, '_blank')}} 
        className='flex items-center justify-center rounded-md border-2 border-theme-orange dark:border-theme-turquoise from-theme-orange to-theme-turquoise hover:bg-gradient-to-br hover:text-dark cursor-pointer'
        style={{
          marginTop: sidebarMode ? "60px": "0", 
          marginLeft: sidebarMode ? "0" : "10px", 
          height: sidebarMode ? "42px" : "24px", 
          width: sidebarMode ? "56px" : "30px",
          padding: sidebarMode ? "7px" : "3px",
          // borderColor: sidebarMode ? "border-light" : "border-light",
        }}
      />
    </>
  }

  return (
    <div className="fixed top-0 bg-light-accent dark:bg-dark-accent bg-opacity-50 dark:bg-opacity-50 w-full z-40 backdrop-blur-sm text-2xl md:text-xl text-dark dark:text-light">
      {/* Navbar */}
      <nav 
        className={`flex justify-between items-center p-2 pl-4 pr-4 m-auto transform transition-width duration-500 ease-in-out`}
        style={{width: `${scrollPosition > 100 ? '100vw' : `${navbarWidth}px`}`}}
      >
        <div className='z-40 flex items-center'>
          <div>
            <LinkRouter to="/" onClick={() => smoothScrollToTop(300)} className="">
              Philipp<span className='font-bold'>Wulff</span>
            </LinkRouter>
          </div>
          <div className="flex ml-3 items-center">
            <DarkModeSwitch theme={theme} setTheme={setTheme}/>
          </div>
        </div>
        { !isMobile ? (
          <div className='flex items-center'>
            {navButtons()}
          </div>
        ) : (
          <button onClick={toggle} className='z-50'>
            <FaHamburger className='p-1 text-4xl text-dark dark:text-light'/>
          </button>
        )}
      </nav>
      {/* Show Sidebar when in mobile mode and toggled */}
      { isToggled ? (
        <div onClick={toggle} className="fixed h-screen w-screen top-0 left-0 z-40 flex items-center justify-center bg-black bg-opacity-90">
          <div className="flex text-2xl flex-col z-50 text-light text-center items-center">
            {navButtons(true)}
          </div>
        </div>
      ) : null}

    </div>
  )
}

export default Navbar
